import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const Products = () => {
  return <ErpTablePage moduleKey="inv_products" />;
};

export default Products;